// Vue
import { Component, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { Api } from "../../../api";
import { ProductCountResponse } from "../../../common/interfaces/unimog/ProductCountResponse";
import { debounce } from "../../../common/Utils";
import { Filter } from "../../../common/interfaces/unimog/Filter";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class ProductFastFilterModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  private branche: string = "";

  private filter: Filter = {
    freitext: "",
    baureihen: [],
    branchen: [],
    aufbaupartner: "",
    fahrzeugtyp: "",
    baumuster: "",
    euronorm: "",
    radstand: "",
    land: "",
    einsatzgebiet: "",
    partnerstatus: "",
  };

  private isLoading: boolean = false;

  private countData: ProductCountResponse | null = null;

  get productCount() {
    if (this.countData) {
      return this.countData.count;
    } else {
      return 0;
    }
  }

  get sortedBranchen() {
    if (this.countData) {
      return this.countData.options.branchen.sort((a, b) => {
        return a.title.localeCompare(b.title);
      });
    } else {
      return [];
    }
  }

  mounted() {
    this.loadData();
  }

  @Watch("filter", { deep: true })
  private onFilterChange() {
    this.loadDataDebounced();
  }

  @Watch("branche")
  private onBrancheChange() {
    this.filter.branchen = [this.branche];
  }

  private loadDataDebounced = debounce(this.loadData, 400);

  public async loadData() {
    this.isLoading = true;
    try {
      this.countData = await Api.unimog.getCount(
        this.filter.freitext,
        [],
        this.filter.branchen,
        this.filter.aufbaupartner,
        this.filter.fahrzeugtyp,
        "",
        "",
        "",
        "",
        "",
        ""
      );
    } catch (err) {
      this.$store.ui.error(
        this.$t("UNIMOG_PRODUCT_COUNT_CAN_NOT_LOAD_DATA") as string
      );
    } finally {
      this.isLoading = false;
    }
  }

  public handleMoreFilter() {
    window.localStorage.setItem("unimog-page-filter__tab", "product");
    window.localStorage.removeItem("unimog-page-filter__filter");
    window.localStorage.setItem(
      "unimog-page-filter__filter--visible",
      JSON.stringify(true)
    );

    if (process.env.NODE_ENV !== "production") {
      window.location.href =
        "?forceUrl=http://int.www.unimogpartner.com/" +
        this.$store.ui.appCurrentLanguage +
        "/GLOBAL/filter";
    } else {
      window.location.href =
        "/" + this.$store.ui.appCurrentLanguage + "/filter";
    }
  }

  public handleSubmit() {
    window.localStorage.setItem("unimog-page-filter__tab", "product");
    window.localStorage.setItem(
      "unimog-page-filter__filter",
      JSON.stringify(this.filter)
    );
    window.localStorage.setItem(
      "unimog-page-filter__filter--visible",
      JSON.stringify(false)
    );

    if (process.env.NODE_ENV !== "production") {
      window.location.href =
        "?forceUrl=http://int.www.unimogpartner.com/" +
        this.$store.ui.appCurrentLanguage +
        "/GLOBAL/filter";
    } else {
      window.location.href =
        "/" + this.$store.ui.appCurrentLanguage + "/filter";
    }
  }
}
